import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { BWIcons, Icons } from '@honeycomb-npm/honeycomb';
import * as PropTypes from 'prop-types';
import * as React from 'react';

var IconCSS = props => {
  var isBankwest = props.theme && props.theme.toLowerCase() === 'bankwest';
  var iconlist = isBankwest ? BWIcons.IconList : Icons.IconList;
  if (typeof iconlist[props.symbol] === 'undefined' || typeof iconlist[props.symbol].css === 'undefined') {
    return null;
  }
  var className = iconlist[props.symbol].css;
  if (props.className) {
    className += " ".concat(props.className);
  }
  return /*#__PURE__*/React.createElement("i", {
    className: className,
    "aria-hidden": "true"
  });
};
var concatedList = _objectSpread2(_objectSpread2({}, Icons.IconList), BWIcons.IconList);
IconCSS.propTypes = {
  className: PropTypes.string,
  symbol: PropTypes.oneOf(Object.keys(concatedList).filter(iconname => {
    if (typeof concatedList[iconname].css === 'undefined') {
      return false;
    }
    return true;
  })).isRequired
};

export { IconCSS };
